export function isOfficeSetSupported(
  name: string,
  minVersion?: string,
): boolean {
  return Office.context.requirements?.isSetSupported(name, minVersion);
}
